/**
 * @file 主题页新增的vue数据store
 */
import * as Types from '../mutation-types';
import fetchData from '../../service';

const state = () => ({
    albumActiveIndex: 0, // 相册当前点击的索引
    albumList: [] // 主题页相册数据
});

const mutations = {
    // 设置请求的主题相册数据数组
    [Types.SET_ALBUM_DATA](state, data) {
        state.albumList = data;
    },
    // 相册当前索引设置
    [Types.SET_ALBUM_ACTIVE_INDEX](state, data) {
        state.albumActiveIndex = data;
    }
};

const getters = {
};
const actions = {
    // 获取当前话题下的全景相册数据
    getFeedByTopic: ({rootState, commit}, params) => {
        let cuid = decodeURIComponent(rootState.urlParams.cuid);
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let abtest = rootState.urlParams.abtest;
        let noCuid = cuid ? 0 : 1;
        const initParams = {
            qt: 'getfeedbytopic',
            cuid,
            abtest
        };
        const fetchParam = Object.assign({}, params, initParams);

        return fetchData('getFeedByTopic', fetchParam, {noCuid: noCuid, need_sign: 1}).then(res => {
            if (res && res.result.error === 0 && res.content && res.content.length) {
                commit(Types.SET_ALBUM_DATA, res.content);
            }
        }).catch(e => {
            console.error(e);
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};